import React from 'react';
import PropTypes from "prop-types";

export class ActionButton extends React.Component {
    render() {
        return (
            <button disabled={this.props.button.disabled} type={this.props.button.type}
                    onClick={this.props.button.onClick} className={"button button-action button-" + this.props.button.class}>
                {this.props.button.text}
            </button>
        );
    }
}
ActionButton.propTypes = {
    button: PropTypes.shape({
        type: PropTypes.string,
        text: PropTypes.string.isRequired,
        disabled: PropTypes.bool,
        class: PropTypes.string,
        onClick: PropTypes.func.isRequired
    }).isRequired,
};

export class ReturnButton extends React.Component {
    constructor(props) {
        super(props);
        this.goBack = this.goBack.bind(this);
    }

    goBack() {
        window.history.back();
    }

    render() {
        return (
            <a onClick={this.goBack} className={"button button-return"} title="Voltar">Voltar</a>
        );
    }
}

export class LinkButton extends React.Component {
    render() {
        return (
            <a
                href={this.props.link.href}
                className={"button button-link button-" + this.props.link.class}
                target={this.props.link.target}
                title={this.props.link.title}
            >{this.props.link.text}</a>
        )
    }
}
LinkButton.propTypes = {
    link: PropTypes.shape({
        href: PropTypes.string.isRequired,
        class: PropTypes.string,
        text: PropTypes.string.isRequired,
        title: PropTypes.string,
        target: PropTypes.string
    }).isRequired
};

export class FacebookButton extends React.Component {
    constructor(props) {
        super(props);
        this.handleFb = this.handleFb.bind(this);
        this.handleErr = this.handleErr.bind(this);
        this.state = {
            facebook: {
                text: props.facebook.text,
                class: "facebook",
                title: "login-facebook",
                onClick: this.handleFb
            }
        }
    }

    componentDidMount() {
        // Facebook Function
        /*global FB*/
        let props = this.props;
        window.fbAsyncInit = function () {
            FB.init({
                appId: props.facebook.id,
                xfbml: true,
                status: true,
                cookie: true,
                version: props.facebook.version
            });
            FB.AppEvents.logPageView();
        };

        (function (d, s, id) {
            let js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s);
            js.id = id;
            js.src = "//connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    }

    handleFb() {
        try {
            let props = this.props;
            FB.login(async function (rr) {
                if (rr.authResponse) {
                    props.facebook.onSuccess(rr.authResponse);
                }
            }, {scope: 'public_profile,email,user_friends'});
        } catch (err) {
            this.handleErr(err);
        }
    }

    handleErr(err) {
        console.log(err);
    }

    render() {
        return (
            <ActionButton button={this.state.facebook}></ActionButton>
        );
    }
}
LinkButton.propTypes = {
    facebook: PropTypes.shape({
        id: PropTypes.string.isRequired,
        version: PropTypes.string.isRequired,
        onSuccess: PropTypes.func.isRequired,
        text: PropTypes.string.isRequired
    }).isRequired
};


// WEBPACK FOOTER //
// ./src/button/Buttons.js